<template>

<v-container class="box">
    <v-layout align-center @click="handleClose" >
        <v-flex xs13>
       <logo-select   class="logo"  @getindex='getIndex'></logo-select>
        <div class="search-input">
            <v-text-field append-icon="mdi-magnify"
          flat
          hide-details
          solo-inverted
          style="max-width: 400px;" type="text"  v-model="keyword" @keyup="get($event)" @keydown.enter="search()" @keydown.down="selectDown()" @keydown.up.prevent="selectUp()"/>
            <!-- 这是一个小叉叉，点击它可清除输入框内容 -->
            <div class="search-select">    
            <!-- transition-group也是vue2.0中的新特性,tag='ul'表示用ul包裹v-for出来的li -->
                <transition-group name="itemfade" tag="ul" mode="out-in" v-cloak>
                    <li  v-for="(value,index) in myData" :class="{selectback:index==now}" class="search-select-option search-select-list" @mouseover="selectHover(index)" @click="selectClick(index)" :key="value">
                        {{value}}
                    </li>
                </transition-group>
            </div>
                <v-btn flat class="search-btn" @click="search()">Search</v-btn>
        <v-btn class="search-reset" @click="clearInput()">&times;</v-btn>
            </div>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script type="text/javascript">
// import xxx from someSrc     es6中得到模块的方法。
import logoSelect from './logo-select.vue';


export default {
    //注册组件
    components: {
        'logo-select': logoSelect
    },
    data: function() {
        return {
            myData: [],//用来接收ajax得到的数据
            keyword: '',//v-model绑定的输入框的value
            now: -1,
            searchIndex: 0,
            logoData: [{
                name: '360搜索',
                searchSrc: 'https://www.so.com/s?ie=utf-8&shb=1&src=360sou_newhome&q='
            }, {
                name: '百度搜索',
                searchSrc: 'https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=0&rsv_idx=1&tn=baidu&wd='
            }, {
                name: '搜狗搜索',
                searchSrc: 'https://www.sogou.com/web?query='
            }]
        }
    },
    methods: {
        handleClose(e) {
         this.show = false;
        },
        // &event是实参，表示event对象
        get: function(ev) {
            // 如果按得键是上或者下，就不进行ajax
            if (ev.keyCode == 38 || ev.keyCode == 40) {
                return;
            }

            this.$http.jsonp('https://sug.so.360.cn/suggest?word=' + this.keyword + '&encodein=utf-8&encodeout=utf-8').then(function(res) {
                this.myData = res.data.s;
            });
        },
        selectDown: function() {
            this.now++;
            //到达最后一个时，再按下就回到第一个
            if (this.now == this.myData.length) {
                this.now = 0;
            }
            this.keyword = this.myData[this.now];
        },
        selectUp: function() {
            this.now--;
            //同上
            if (this.now == -1) {
                this.now = this.myData.length - 1;
            }
            this.keyword = this.myData[this.now];
        },
        search: function() {
            //打开对应的搜索界面
            window.open(this.logoData[this.searchIndex].searchSrc + this.keyword);
        },
        selectHover: function(index) {
            this.now = index
        },
        selectClick: function(index) {
            this.keyword = this.myData[index];
            this.search();
        },
        clearInput: function() {
            this.keyword = '';
            this.$http.jsonp('https://sug.so.360.cn/suggest?word=' + this.keyword + '&encodein=utf-8&encodeout=utf-8').then(function(res) {
                this.myData = res.data.s;
            });
        },
        getIndex: function(index) {
            this.searchIndex = index;
        }
    }
}
</script>

<style type="text/css" scoped>
.box{
background: url('../assets/background.png') no-repeat;
background-attachment: fixed;
background-position: center;
width: 100%;
height: 100%;
align-content: center;
align-items: center;
align-self: center
}
.search-input {
    height: auto;
    width: auto;
    max-width: 400px;
    margin: 0 auto;
    margin-top: 10px;
    position: relative;
}

.search-input input {
    background-color: rgb(255, 255, 255);
    border: 1px solid #e4e4e4;
    box-sizing: border-box;
    font-size: 18px;
    float: left;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
}

.search-btn {
    left: 2%;
    right: 1%;
    float: right;
    margin-left:15px;
    width: 100px;
    border: 1px solid mediumseagreen;
    background-color: rgb(37, 168, 255);
    color: rgb(15, 15, 15);
    font-size: 16px;
    font-weight: bold;
}


.search-select {
    position: absolute;
    top: 45px;
    width: auto;
    box-sizing: border-box;
    z-index: 999;
}

.search-select li {
    border: 1px solid #d4d4d4;
    ;
    border-top: none;
    border-bottom: none;
    background-color: #fff;
    width: 100%
}

.search-select-option {
    box-sizing: border-box;
    padding: 7px 10px;
}

.selectback {
    background-color: #eee !important;
    cursor: pointer
}

input::-ms-clear {
    display: none
}

.search-reset {
    left: 5%;
    right: 0;
    float: right;
    margin-left: 10px;
    cursor: pointer;
    font-size: 20px;

}

.search-select-list {
    transition: all 0.5s
}

.itemfade-enter,
.itemfade-leave-active {
    opacity: 0;
}

.itemfade-leave-active {
    position: absolute;
}

.selectback {
    background-color: #eee !important;
    cursor: pointer
}
.search-select ul{margin:0;text-align: left; }
</style>
